import { Button } from "@mantine/core";
import { IconExternalLink } from "@tabler/icons-react";
import { DSSCalendar as DSSCalendarComponent } from "src/components/pages/Settings/AdvancedFeatures/DSSCalendar/DSSCalendar";
import Breadcrumbs from "src/components/shared/Breadcrumbs/Breadcrumbs";
import { ButtonsWrapper, PageContainer } from "src/styled";
import { DSS_DASHBOARD_URL } from "src/utils/dss/dss.constants";

const DSSCalendar = () => {
  return (
    <PageContainer>
      <Breadcrumbs>
        <ButtonsWrapper>
          <Button
            component="a"
            href={DSS_DASHBOARD_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="outline"
            rightSection={<IconExternalLink size="1.2rem" />}>
            Go To Dashboard
          </Button>
        </ButtonsWrapper>
      </Breadcrumbs>
      <DSSCalendarComponent />
    </PageContainer>
  );
};

export default DSSCalendar;
